import {Proxy} from "../../../settings";
import {baseGetRequest} from "../base/baseGetRequest";
import {affilateRegionType} from "./getAffiliateRegion";

const getAffilateRegions = async () =>
  baseGetRequest<affilateRegionType>(`${Proxy}/affilate_region/`, undefined);

export default getAffilateRegions;
